<div class="flex flex-col flex-1 h-full patternBG">

  <!-- Header -->
  <app-header-auth *ngIf="!loader" [currComp$]="currComp$"></app-header-auth>

  <!-- Main comp  -->
  <div class="flex flex-col layout-padd scrolled">

    <!-- Content -->
    <div ngClass.xs="layout-padd" style="margin-bottom: 10px;">

      <!-- Code SMS invalide -->
      <div class="p-4 text-center form-auth mx-auto border border-gray-300 text-orange-800
          bg-white bg-opacity-50 rounded-lg shadow-lg mb-6" *ngIf="invalidSmsCode">
        <p  class="text-sm">
          Le code SMS n'est pas valide.<br/>Votre compte MyFülle ne sera pas associé à votre commerçant.
        </p>
      </div>

      <!-- Message de bienvenue sms notif -->
      <div class="p-4 text-center form-auth mx-auto border border-gray-300
          bg-white bg-opacity-50 rounded-lg shadow-lg mb-6" *ngIf="smsNotif">
        <p  class="text-sm">
          Bienvenue sur le club MyFülle ! 🌟<br/>
          Vous êtes client de <span class="font-bold">{{smsNotif.point_of_sale.denomination}}</span> ?<br/>
          <br/>Créez votre compte ou connectez-vous pour profiter pleinement de nos services et des avantages
          exclusifs réservés aux clients de {{smsNotif.point_of_sale.denomination}}.
        </p>
      </div>

      <!-- Components -->
      <app-login *ngIf="currComp$ === 'login'" [redirectPage]="redirectPage"></app-login>
      <app-register *ngIf="currComp$ === 'register'" [smsNotif]="smsNotif" [redirectPage]="redirectPage"></app-register>
      <app-forgot-password *ngIf="currComp$ === 'forgotpass'"></app-forgot-password>

    </div>

  </div>

  <app-popup-loader [flagLoading]="loader" [statusMessage]="'loaderText.data'|translate" [size]="30">
  </app-popup-loader>

</div>
